var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#fea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.448 23.5c0 2.572-1.822 4.77-5.147 5.348v2.948h-2.834v-2.744c-1.938-.088-3.817-.61-4.915-1.244l.867-3.384c1.215.667 2.92 1.274 4.8 1.274 1.648 0 2.776-.638 2.776-1.794 0-1.099-.925-1.797-3.066-2.518-3.092-1.041-5.204-2.486-5.204-5.289 0-2.546 1.793-4.538 4.887-5.147V8.204h2.833v2.544c1.937.087 3.24.49 4.193.954l-.839 3.27c-.75-.32-2.08-.986-4.163-.986-1.88 0-2.487.809-2.487 1.62 0 .953 1.013 1.56 3.47 2.487 3.443 1.213 4.83 2.803 4.83 5.407z"
  })));
}

export default SvgCurrency;